import React, { useCallback, useEffect, useState } from 'react';
import { TabPanel, Tabs } from '@tencent/spaui';
import _ from 'lodash';
import TipIcon from '@/common-components/tip-icon';
import globalStore from '@/stores/index';
import './assets/less/index.scoped.less';


export interface LeafNavProps {
  /**
   * 页面地址
   */
  href?: string;
  /**
   * 页面地址
   */
  endOfHeadContent?: any;
}

export const LeafNav: React.FC<LeafNavProps> = (props) => {
  const { href = '', endOfHeadContent } = props;
  const account: any = globalStore.account || {};
  const history: any = globalStore.history || {};
  const pathname = href || history?.location?.pathname;
  const [value, setValue] = useState(pathname);
  const { siteMap = {} } = account;
  const currentTabNav: any[] = siteMap.pathLeafNavMap?.[pathname] || [];

  useEffect(() => {
    if (currentTabNav) {
      currentTabNav.forEach((item, index) => {
        if (item.match && item.match(pathname)) {
          setValue(item.href);
        }
      });
    }
  }, [pathname]);

  const onChange = useCallback((e, value) => {
    setValue(value);
    history?.push(value);
  }, []);

  if (!currentTabNav.length) {
    return null;
  }

  return (
    <Tabs className="tab-nav" value={value} unmountInactivePanel={true} needSlider={false} onChange={onChange} endOfHeadContent={<div className="tab-nav-right">{endOfHeadContent}</div>}>
      {currentTabNav.map((item) => {
        const href = item.href;
        return (
          <TabPanel
            key={href}
            tab={
              item.tip ? (
                <TipIcon value={item.label}>{item.tip}</TipIcon>
              ) : (
                item.label
              )
            }
            name={href}
            data-report-global={`second-nav.${item.key || item.id || item.href}`}
          ></TabPanel>
        );
      })}
    </Tabs>
  );
};

export default LeafNav;

